<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="formLoading" />
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="11">{{ $t('El. pašto adresai, kuriais informuojami asmenys apie gautas NIRVAR sritis ar paslaugas / veiksmus') }}</v-col>
          <v-col style="text-align: end;" cols="1">
            <v-icon  
              class="table-action mx-1"
              @click="switchCollapse()">
              {{ collapsed ? 'mdi-chevron-right' : 'mdi-chevron-down' }}</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
          <template v-if="collapsed">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" sm="12" md="6" lg="4">
                <el-text-field 
                  label="El. pašto adresas"
                  v-model="updatedEmails[0]"
                  hide-details
                  :maxlength="150"
                />
              </v-col>
            </v-row>
          </template>
          <template v-if="!collapsed">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" sm="12" md="6" lg="4" v-for="(email, index) in updatedEmails" :key="index">
                    <el-text-field
                      label="El. pašto adresas"
                      v-model="updatedEmails[index]"
                      email
                      required
                      :maxlength="150"
                      :validateKey="'emailAddress-' + index"
                    >
                      <template slot="append">
                        <slot name="append">
                          <v-icon 
                            v-if="updatedEmails.length > 1"
                            dense 
                            class="mt-1"
                            @click="removeEmailField(index)">
                              mdi-delete-outline
                          </v-icon>
                        </slot>
                      </template>
                    </el-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Atšaukti"
                  :loading="formLoading"
                  color="secondary"
                  icon="atšaukti"
                  @click.native="restoteEmails()"
                />
                <el-button
                  class="mr-1"
                  title="Pridėti el. paštą"
                  :loading="formLoading"
                  color="primary"
                  icon="pridėti"
                  @click.native="addEmailField()"
                />
                <el-button
                  color="primary"
                  icon="išsaugoti"
                  title="Išsaugoti"
                  :loading="formLoading"
                  @click.native="saveEmails()"
                />
              </v-col>
            </v-row>
          </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

export default {
  name: 'NirvarEmails',
  props: {
    loading: Boolean,
  },
  data: () => ({
    pageLoading: false,
    loadDefault: null,
    collapsed: true,
    emails: [
        ''
    ],
    updatedEmails: [
        ''
    ],
  }),
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getEmails()
  },
  computed: {
    formLoading(){
      return this.loading || this.pageLoading
    }
  },
  methods: {
    getEmails() {
      this.pageLoading = true
      let url = `nirvar-emails`
      this.$axios
        .get(url)
        .then((res) => {
          if (res.data.emails.length > 0) {
            this.emails = res.data.emails
            this.updatedEmails = res.data.emails
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    saveEmails() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.pageLoading = true
          let url = `nirvar-emails`      
          this.$axios
            .post(url, {emails: this.updatedEmails})
            .then((res) => {
              if (res.data.emails.length > 0) {
                this.emails = res.data.emails
              }
              this.$root.$emit('DATA_OK', 'El. pašto adresai išsaugoti')
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.pageLoading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    restoteEmails() {
      this.updatedEmails = this.emails
    },
    addEmailField() {
      this.updatedEmails.push('')
    },
    removeEmailField(index) {
      this.updatedEmails.splice(index, 1)
    },
    switchCollapse() {
      this.collapsed = !this.collapsed
    }
  },
}
</script>
